// removed by extract-text-webpack-plugin
module.exports = {"root":"contact-form--root--2EWScI45","action":"contact-form--action--2OHKmcUL","button":"contact-form--button--ehkgu_mz","success":"contact-form--success--2h3XLhPe","title":"contact-form--title--1lxbFlf5","subtitle":"contact-form--subtitle--OB-TXf8p"};


//////////////////
// WEBPACK FOOTER
// ./views/contact-form/styles.css
// module id = ./views/contact-form/styles.css
// module chunks = 0